import React from 'react';
import { connect } from 'react-redux';

import PresentationComponent from '../../components/dashboards/tabcomponents/TemplateDrawerMenu';
import UsersTemplateDrawer from './UsersTemplateDrawer';

const mapStateToProps = () => ({
  templateDrawer: (collapsed, setCollapsed) => (
    <UsersTemplateDrawer collapsed={collapsed} setCollapsed={setCollapsed} />
  ),
});

const UsersTemplateDrawerMenu = connect(mapStateToProps, null)(PresentationComponent);

export default UsersTemplateDrawerMenu;
